import {
  GET_SURVEY,
  GET_SURVEY_SUCCESS,
  GET_SURVEY_FAIL,
  DELETE_SURVEY,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAIL,
  UPDATE_SURVEY,
  UPDATE_SURVEY_SUCCESS,
  UPDATE_SURVEY_FAIL,
  ADD_NEW_SURVEY,
  ADD_SURVEY_SUCCESS,
  ADD_SURVEY_FAIL,
  SURVEY_LOADING,
  SURVEY_RESET,
} from "./actionType";

export const resetSurveyState = (actionType) => ({
  type: SURVEY_RESET,
  payload: { actionType },
});

export const getSurveySuccess = (actionType, data) => {
  return {
    type: GET_SURVEY_SUCCESS,
    payload: { actionType, data },
  };
};

export const getSurveyFail = (actionType, error) => {
  return {
    type: GET_SURVEY_FAIL,
    payload: { actionType, error },
  };
};

export const getSurvey = (data) => ({
  type: GET_SURVEY,
  payload: data,
});

export const getSurveyLoading = () => ({
  type: SURVEY_LOADING,
});

export const deleteSurvey = (data) => ({
  type: DELETE_SURVEY,
  payload: data,
});

export const deleteSurveySuccess = (data) => ({
  type: DELETE_SURVEY_SUCCESS,
  payload: data,
});

export const deleteSurveyFail = (error) => ({
  type: DELETE_SURVEY_FAIL,
  payload: error,
});

export const updateSurvey = (data) => ({
  type: UPDATE_SURVEY,
  payload: data,
});

export const updateSurveyFail = (error) => ({
  type: UPDATE_SURVEY_FAIL,
  payload: error,
});

export const updateSurveySuccess = (data) => ({
  type: UPDATE_SURVEY_SUCCESS,
  payload: data,
});

export const addNewSurvey = (data) => ({
  type: ADD_NEW_SURVEY,
  payload: data,
});

export const addSurveySuccess = (data) => ({
  type: ADD_SURVEY_SUCCESS,
  payload: data,
});

export const addSurveyFail = (error) => ({
  type: ADD_SURVEY_FAIL,
  payload: error,
});
